import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  categoryName: "all",
  priceRange: [1, 5000],
  orderBy: "",
  serachQuery: "",
  allProductList: [],
  isAllProductLoading: true,
};

const searchSlice = createSlice({
  name: "search",
  initialState: initialState,
  reducers: {
    setCategoryName(state, action) {
      state.categoryName = action.payload;
    },
    setSerachQuery(state, action) {
      state.serachQuery = action.payload;
    },
    setAllProductList(state, action) {
      state.allProductList = action.payload;
    },
    setIsAllProductLoading(state, action) {
      state.isAllProductLoading = action.payload;
    },
    setPriceRange: (state, action) => {
      state.priceRange = action.payload;
    },
    setOrderBy: (state, action) => {
      state.orderBy = action.payload;
    },
    resetFilters: (state) => {
      state.serachQuery = "";
    },

    appendAllProductList: (state, action) => {
      state.allProductList = [...state.allProductList, ...action.payload];
    },

    clearAllProductList: (state) => {
      state.allProductList = [];
    },
  },
});

export const {
  setCategoryName,
  setSerachQuery,
  setAllProductList,
  setIsAllProductLoading,
  setPriceRange,
  setOrderBy,
  resetFilters,
  appendAllProductList,
  clearAllProductList,
} = searchSlice.actions;

export default searchSlice.reducer;
